import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Divider,
  Button,
  Theme,
} from '@material-ui/core';



const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
    },
    grid: {
      marginBottom: theme.spacing(2),
    },
    title: {
      fontWeight: 700,
    },
    iconBackgound: {
      backgroundColor: 'grey',
      height: 56,
      width: 56,
    },
    icon: {
      height: 32,
      width: 32,
    },
    footer: {
      marginTop: theme.spacing(2),
    }
  })
);

const Trash = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid className={classes.grid} container justify="space-between">
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              NEXT ON TRASH SCHEDULE
            </Typography>
            <Typography variant="h4">Kaloyan (Tomorrow)</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.iconBackgound}>
              <DeleteIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
        <Divider></Divider>

        <div className={classes.footer}>
          <Typography variant="caption">
            <Button component={Link} to="/balance" variant="outlined">
              complete schedule
            </Button>
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default Trash;
